export default "__VITE_ASSET__DqOLRfpX__"